export const FETCH_PAYMENTSVOUCHERMASTERS= 'FETCH_PAYMENTSVOUCHERMASTERS';
export const PUSH_PAYMENTSVOUCHERMASTERS= 'PUSH_PAYMENTSVOUCHERMASTERS';
export const REMOVE_PAYMENTSVOUCHERMASTERS= 'REMOVE_PAYMENTSVOUCHERMASTERS';
export const UPDATE_PAYMENTSVOUCHERMASTERS= 'UPDATE_PAYMENTSVOUCHERMASTERS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchPaymentsVoucherMasters(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_PAYMENTSVOUCHERMASTERS,
      payload:data
    });
  }
}

export function pushPaymentsVoucherMasters(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_PAYMENTSVOUCHERMASTERS,
      payload:data
    });
  }
}

export function removePaymentsVoucherMasters(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_PAYMENTSVOUCHERMASTERS,
      payload:data
    });
  }
}

export function updatePaymentsVoucherMasters(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_PAYMENTSVOUCHERMASTERS,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActivePaymentsVoucherMasters(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
